
import { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  className?: string;
  onClick?: () => void;
}

export default function Card({ children, className = '', onClick }: CardProps) {
  return (
    <div 
      className={`bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-700 rounded-2xl shadow-lg dark:shadow-slate-900/20 transition-all duration-300 ${
        onClick ? 'cursor-pointer hover:shadow-xl dark:hover:shadow-slate-900/30' : ''
      } ${className}`}
      onClick={onClick}
    >
      {children}
    </div>
  );
}
